import * as React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { PageLoading } from "components/Layout";

const ListPost = React.lazy(() => import("./views/ViewListPost"));

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <React.Suspense fallback={<PageLoading />}>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/posts`} />
        </Route>
        <Route path={`${path}/posts`}>
          <ListPost />
        </Route>
      </Switch>
    </React.Suspense>
  );
};

export default Routes;
